import { Component, DestroyRef, OnInit, signal, WritableSignal, inject } from '@angular/core';
import { DialogHeaderComponent, BaseDialogComponent } from '@cumlaude/shared-components-dialogs';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { marked } from 'marked';
import { RestService } from '@cumlaude/shared-services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { reverse } from 'lodash-es';

@Component({
	selector: 'app-releasenotes-dialog',
	templateUrl: './release-notes-dialog.component.html',
	styleUrls: ['./release-notes-dialog.component.scss'],
	imports: [BaseDialogComponent, DialogHeaderComponent, IconComponent],
})
export class ReleaseNotesDialogComponent implements OnInit {
	private readonly restService = inject(RestService);
	private readonly destroyRef = inject(DestroyRef);

	readonly notes: WritableSignal<string[]> = signal([]);

	readonly detail: WritableSignal<string | undefined> = signal(undefined);

	ngOnInit() {
		this.restService
			.getReleaseNotes()
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((notes_md) => this.notes.set(this.processResponse(notes_md)));
	}

	processResponse(notes_md: string[]): string[] {
		const parsed = notes_md.map((md) => <string>marked.parse(md));
		return reverse(parsed);
	}

	openNote(note: string) {
		this.detail.set(note);
	}

	closeNote() {
		this.detail.set(undefined);
	}
}
